<template>
  <div class="setting-index">
<!--      设置-->
    <transition name="fade-transform" mode="out-in">
    <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'setting-index',
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">

</style>
